import { Link } from 'react-router'

import { Button } from '@/components/ui/button'
import GameLayout from '@/layouts/GameLayout'
import { Images } from '@/assets/Images'

const JDTool = () => {
  return (
    <GameLayout>
      {/* Main Content - Folder Style Card */}
      <div className="flex items-center justify-center w-full px-4">
        <div className="animate-in zoom-in-95 fade-in relative duration-500">
          {/* Main Card */}
          <div
            className="rounded-t-3xl xl:p-20 xl:pt-[168px] xl:py-25 w-full xl:w-[1100px] relative p-6 pt-[168px]"
            style={{
              backgroundImage: `url(${Images.folder_background})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          >
            {/* Content */}
            {/* Title Section */}
            <div className="mb-15">
              <span className="font-momo-trust-display xl:text-[60px] xl:leading-[70px] md:text-[50px] md:leading-[60px] text-[40px] leading-[50px] text-black">
                Untold Job Description <br /> Phần công việc chưa được kể
              </span>

              <p className="mt-8 text-black font-normal text-[20px] leading-[30px] xl:text-[30px] xl:leading-[40px]">
                15 năm qua, MoMo đi lên từ những bước nhỏ, nhờ hàng nghìn MoMoers luôn làm nhiều hơn
                phần việc của mình.
                <br />
                Những đầu việc chưa từng có trong JD chính thức, được làm âm thầm, rất đáng tự hào
                nhưng ít ai biết.
                <br />
                <span className="font-bold">Giờ là lúc những việc không tên được kể ra.</span>
              </p>
            </div>

            {/* Buttons Section */}
            <div className="flex flex-wrap gap-4">
              <Button asChild className="w-fit btn-primary font-normal">
                <Link to="/create-jd">Viết Untold JD cho chính mình</Link>
              </Button>

              <Button asChild className="w-fit btn-primary">
                <Link to="/send-jd">Viết Untold JD cho đồng đội</Link>
              </Button>
              <Button asChild className="w-fit btn-primary">
                <Link to="/library-jd">Untold JD của MoMoer</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </GameLayout>
  )
}

export default JDTool
